$(function () {
  $(".js-accordion-gift").each(function (index, el) {
    if ($(el).hasClass('footer-accordion')) {
      // FIX: ignore because bundle.js is listening
      console.log('ignore')
    } else {
      Accordion($(el))
    }
  })
  GetCartData()
  //submitはご購入手続きをクリックした時だけ
  $("#checkout").on("click", function () {
    const cartSubmitInput = document.createElement('input')
    cartSubmitInput.setAttribute('name', 'checkout')
    cartSubmitInput.setAttribute('type', 'hidden')
    document.querySelector('#cart').appendChild(cartSubmitInput)
    $("#cart").submit()
  })
})

// のし設定をやめる
$("body").on("click", ".js-confirm-noshi", function () {
  var options = {
    text: "掛紙(のし)の設定をやめますか？\nやめると設定内容は破棄されます。",
    buttons: {
      cancel: "設定を続ける",
      ok: "やめる",
    },
  }
  swal(options).then(function (value) {
    if (value == 'ok') {
      // 「やめる」の処理
      swal.close()
      window.location.reload()
    }
  })
})

// 手提げ袋あり・なし
$('body').on('click', '.giftbag', function () {
  var line = $(this).data('line')
  var $giftbag_false = $('#giftbag-01' + line)
  var $giftbag_true = $('#giftbag-02' + line)
  var $wrapping_false = $('#wrapping-01' + line)
  if (this.checked) {
    $giftbag_true.css('display', 'block')
    $giftbag_false.css('display', 'none')
    $wrapping_false.css('paddingTop', '100%')
  } else {
    $giftbag_true.css('display', 'none')
    $giftbag_false.css('display', 'block')
    $wrapping_false.css('paddingTop', '0')
  }
})

/**
 * 「包装＋のし」をクリックした時のモーダル表示処理
 * bundle.jsの処理を抜き出しつつ、トリガーのクラス名を変更してこちらのみで処理を拡張できるように対応
 */
$('.js-modal-trigger-gift').on('click', function (event) {
  // デフォルトのイベントをキャンセル
  event.preventDefault()

  // 変数定義
  const modalName = $(event.currentTarget).attr('data-modal')
  const $modal = $('#' + modalName)
  const $body = $('body')
  const bodyOverflow = $body.css('overflow')
  const hideModal = () => {
    $modal.removeClass('is-active')
    $body.css('overflow', bodyOverflow)
  }

  // 背景スクロールしないように
  $body.css('overflow', 'hidden')

  // modalElementに'is-active'クラスがある場合、処理を実行。そうでない場合、'is-active'クラスを追加
  if ($modal.hasClass('is-active')) {
    hideModal()
  } else {
    $modal.addClass('is-active')
  }

  // モーダル外側の要素をクリックした場合、処理を実行
  $modal.find('.js-modal-bg').on('click', function (event) {
    event.preventDefault()
    hideModal()
  })

  // モーダル内側の閉じるボタンをクリックした場合、処理を実行
  $modal.find('.js-modal-close').on('click', function (event) {
    event.preventDefault()
    hideModal()
  })

  // '[data-close=modal]'属性を持つ要素をクリックした場合、処理を実行
  $modal.find('[data-close=modal]').on('click', function (event) {
    event.preventDefault()
    hideModal()
  })

})

// のし設定.p-cart-noshi__input-textのテキスト入力内容を全て全角に変換する、setimeoutで1秒後に実行
/*var timer = false
$('body').on('focusout blur compositionend change', '.p-cart-noshi__input-text', function() {
  if (timer !== false) {
    clearTimeout(timer)
  }
  var _this = this
  timer = setTimeout(function() {
    var text = $(_this).val()
    var zenkaku = text.replace(/[A-Za-z0-9]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) + 0xFEE0)
    })
    $(_this).val(zenkaku)
  }, 400)
})*/

$('body').on('click', '.btn-gift-submit', function () {
  if (gift.line == $(this).data('line')) {
    console.log(gift.line)
    // のしのかけ方保存用
    const $noshiStyle1 = $('#noshi_style-01' + gift.line)
    const $noshiStyle2 = $('#noshi_style-02' + gift.line)
    if ($noshiStyle1.prop('checked')) {
      gift.style = '内のし'
    } else if ($noshiStyle2.prop('checked')) {
      gift.style = '外のし'
    }

    var giftParam = {
      line: gift.line, properties: {
        'お仕立て': gift.name, 'のし': gift.noshi,
        '表書き': $('#noshi-content' + gift.line).val(), 'お名前': $('#noshi-recipient' + gift.line).val(), 'のしのかけ方': gift.style
      }
    }
    var body = JSON.stringify(GetLineItemProperties(giftParam))

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      }).then((state) => {
        window.location.reload()
      }).catch(() => {
      })
  }
})

$('body').on('click', '.p-cart-noshi__back', function () {
  var line = $(this).data('line')
  $('#modal-noshi2' + line).removeClass('is-active')
  $('#modal-noshi1' + line).addClass('is-active')
})

// アコーディオン
function Accordion($target) {
  const $accordion = $target
  const $accordionTrigger = $accordion.find(".js-accordion-gift-trigger")
  const $accordionContent = $accordion.find(".js-accordion-gift-content")
  const $accordionWrap = $accordion.closest(".js-accordion-gift-wrap")[0] ? $accordion.closest(".js-accordion-gift-wrap") : ""
  if ($accordion.hasClass("active")) {
    $accordionContent.stop(true).show()
  }
  $accordionTrigger.off("click")
  $accordionTrigger.off().on("click", () => {
    if ($accordionContent.is(":hidden")) {
      if ($accordionWrap) {
        $accordionWrap.find(".js-accordion-gift.active .js-accordion-gift-content").stop(true).slideUp()
        $accordionWrap.find(".js-accordion-gift.active").removeClass("active")
      }
      $accordion.addClass("active")
      $accordionContent.removeAttr('hidden')
      $accordionContent.stop(true).slideDown()
    } else {
      $accordion.removeClass("active")
      $accordionContent.attr('hidden')
      $accordionContent.stop(true).slideUp()
    }
  })
}

var items = []
var gift = {}

function UpdateCartGift(event) {
  var itemLine = event.target.closest(".p-cart-item__detail").dataset.line

  switch (event.target.value) {
    case '1':
    case '2':
    case '3':
      var giftname = event.target.dataset.giftName
      var giftParam = {
        line: itemLine, properties: {
          'お仕立て': giftname
          , 'のし': '', '表書き': '', 'お名前': '', 'のしのかけ方': ''
        }
      }
      var body = JSON.stringify(GetLineItemProperties(giftParam))
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text()
        }).then(() => {
          window.location.reload()
        })
      break;
    case '手提袋が必要':
      var giftParam = { line: itemLine, properties: { '手提げ袋': event.target.checked ? 'あり' : 'なし' } }
      var body = JSON.stringify(GetLineItemProperties(giftParam))
      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text()
        }).then((state) => {
          const parsedState = JSON.parse(state)
          items = parsedState.items
        })
      break;
    default:
      if (event.target.name.indexOf("noshi_") === 0) {
        $('#modal-noshi1' + itemLine).removeClass('is-active')
        $('#modal-noshi2' + itemLine).addClass('is-active')

        var giftname = document.querySelector('.noshigiftname').dataset.giftName
        let modalNoshi2 = $('#modal-noshi2' + itemLine)

        if(event.target.dataset.noshi) {
          const noshi = document.querySelectorAll('.p-cart-noshi__preview-style input')
          for(let n of noshi) {
            n.dataset.noshi = event.target.dataset.noshi
          } 
        }
        
        gift.noshi = event.target.dataset.noshi
        gift.line = itemLine
        gift.type = '4'
        gift.name = giftname

        if (event.target.id.includes('other')) {
          let $content = modalNoshi2.find('#noshi-content' + itemLine)
          // if ($content.data('default') === '') {
          $('#noshi-content' + itemLine).prop('disabled', false).val('')
          // } else {
          // $('#noshi-content' + itemLine).prop('disabled', false).val($content.val());
          // }
        } else {
          //選択された表書きをinputに反映する
          if(!event.target.classList.contains('js-noshi-style-radio')) {
            modalNoshi2.find('#noshi-content' + gift.line).val(gift.noshi)
          }
        }
      } else if (event.target.name.indexOf("noshi_style") != -1) {
        var style1 = $('#noshi_style-01' + itemLine)
        var style2 = $('#noshi_style-02' + itemLine)
        gift.style = style1.is(":checked") ? style1.val() : style2.val()
      }
      break
  }
}

function GetLineItemProperties(giftParam) {
  var properties = {}
  var quantity = 0
  items.forEach(
    (item, index) => {
      if (index + 1 == giftParam.line) {
        properties = { ...item.properties, ...giftParam.properties }
        quantity = item.quantity
      }
    }
  )
  return { line: giftParam.line, 'quantity': quantity, 'properties': properties }
}

function GetCartData() {
  fetch(`${routes.cart_url}`, { ...fetchConfig() })
    .then((response) => {
      return response.text()
    }).then((state) => {
      const parsedState = JSON.parse(state)
      items = parsedState.items
    }).catch(() => {
    })
}
